import SVG from './SVG'

export const NavRightArrowSVG = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g className="arrow-right">
        <path
          fillRule="evenodd"
          d="M12.707 4.293a1 1 0 10-1.414 1.414L16.586 11H5a1 1 0 100 2h11.586l-5.293 5.293a1 1 0 001.414 1.414l7-7a1 1 0 000-1.414l-7-7z"
          className="Union"
          clipRule="evenodd"
        />
      </g>
    </SVG>
  )
}
